const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

export default scrollToRef;
